import React, { useRef, useEffect } from 'react';
import { Menu } from '@headlessui/react';
import { useSidebarMenu } from '../../context/CustomVerticalMenuContext';

interface MenuOption {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  onClick: () => void;
}

interface MenuSectionProps {
  options: MenuOption[];
}

interface ProfileDropdownProps {
  imageUrl?: string;
  altText: string;
  sections: MenuSectionProps[];
  icon?: React.ReactNode;
  menuItemsClassName?: string;
  triggerRef?: React.RefObject<HTMLButtonElement>;
  nameFirstLetter?:string
}

const MenuSection: React.FC<MenuSectionProps> = ({ options }) => (
  <div className="py-[6px]">
    {options.map((option, index) => (
      <Menu.Item key={index}>
        {({ active }) => (
          <a
            href="#"
            className={`group gap-x-3 flex items-center px-4 py-[6px] text-sm ${active ? 'bg-gray-100 text-text-100' : 'text-text-100'
              }`}
            onClick={option.onClick}
          >
            {option.icon && (
              <option.icon
                aria-hidden="true"
                className="mr-0 h-4 w-4 text-text-100 group-hover:text-text-100 opacity-40"
              />
            )}
            {option.label}
          </a>
        )}
      </Menu.Item>
    ))}
  </div>
);

// --- HELPER COMPONENT TO SYNC STATE ---
// This isolates the side effect so it doesn't happen during the main render phase
const MenuStateSync = ({ open, setSidebarState }: { open: boolean, setSidebarState: (state: boolean) => void }) => {
  useEffect(() => {
    setSidebarState(open);
  }, [open, setSidebarState]);

  return null;
};

const CustomMenuDropdownVertical: React.FC<ProfileDropdownProps> = ({ icon, imageUrl, altText, sections, menuItemsClassName, triggerRef,nameFirstLetter}) => {
  const validSections = Array.isArray(sections) ? sections : [];
  const { setcustomVerticleSidebar } = useSidebarMenu();
  const internalButtonRef = useRef<HTMLButtonElement>(null);
  
  // Use provided ref or internal ref
  const buttonRef = triggerRef || internalButtonRef;

  return (
    <Menu as="div" className="group relative inline-block text-left">
      {({ open }) => {
        // Update context state based on menu open/close
        // setcustomVerticleSidebar(open);
        <MenuStateSync open={open} setSidebarState={setcustomVerticleSidebar} />

        return (
          <>
            <div>
              <Menu.Button ref={buttonRef} className="flex items-center rounded-full bg-transparent outline-none focus:outline-none hover:outline-none text-sm">
                <span className="sr-only">Open user menu</span>
                {imageUrl ? (
                  <img className="h-6 w-6 rounded-full" src={imageUrl} alt={altText} />
                ) : (
                   <div className="h-6 w-6   border-[#f5f5f5] rounded-full bg-white flex items-center justify-center">
                    <span className="text-gray-500 text-sm"> {nameFirstLetter}</span>
                  </div>
                  // <span className="h-6 w-6 rounded-full flex items-center justify-center"></span>
                )}
              </Menu.Button>
            </div>
            <Menu.Items
              className={`absolute capitalize bottom-[-10px] left-[42px] right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-[#ebebef] rounded-md bg-white shadow-lg ring-1
            ring-black ring-opacity-5 focus:outline-none custom-dropdown-header ${menuItemsClassName || 'left-0'}`}
            >
              {validSections.map((section, index) => (
                <MenuSection key={index} options={section.options} />
              ))}
            </Menu.Items>
          </>
        );
      }}
    </Menu>
  );
};

export default CustomMenuDropdownVertical;